/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import Spinner from 'react-bootstrap/Spinner'
import { Table } from 'react-bootstrap-v5'

interface ItemCreateProps {
	show: boolean;
	handleClose: any;
	salesOrderInfo: any;
	id: number;
}

interface OrderData {
	idSalesOrders: number;
	idProjects: number;
	idWarehouses?: number | string;
	projectName: string;
	shippingAddress: string;
	returnDate: string;
	chalanNo: string;
	vehicleNo: string;
	driverName: string;
	driverPhoneNo: string;
	remarks: string;
}

interface UnitProduct {
	idProducts: number;
	productName: string;
	packing: string;
}

interface OrderRows {
	id_sales_order_rows: number;
	idProducts: number;
	quantity: number;
	rate: number;
	discount: number;
	originalAmount: number;
	amount: number;
	originalRate: number;
	product_name: string;
	packing: string;
	unit_rate: number;
	already_delivered: number;
	already_returned: number;
	already_returned_loose?: number;
	is_multi_pack?: boolean;
	pack_count?: number;
	unit_liters?: number;
	max_loose_units?: number;
	unit_product?: UnitProduct | null;
	return_quantity?: number | string;
	receive_loose_units?: boolean;
	loose_unit_quantity?: number | string;
	id_loose_unit_products?: number | null;
	[key: string]: any;
}

const initialOrderData: OrderData = {
	idSalesOrders: 0,
	idProjects: 0,
	idWarehouses: '',
	projectName: '',
	shippingAddress: '',
	returnDate: '',
	chalanNo: '',
	vehicleNo: '',
	driverName: '',
	driverPhoneNo: '',
	remarks: '',
}

const parseQty = (value: number | string | undefined | null) => {
	if (value === '' || value === null || value === undefined) {
		return 0;
	}
	const n = parseFloat(String(value));
	return Number.isFinite(n) ? n : 0;
}

const ProductReturn: React.FC<ItemCreateProps> = ({ show, handleClose, salesOrderInfo, id }) => {

	const [orderData, setOrderData] = useState<OrderData>(initialOrderData);
	const [orderRows, setOrderRows] = useState<OrderRows[]>([]);
	const [warehouses, setWarehouses] = useState([]);
	const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });

	useEffect(() => {
		setOrderData(initialOrderData)
		setOrderRows([])
		setWarehouse({ label: 'Select Warehouse', value: '' })
		setWarehouses([])
		if (salesOrderInfo && salesOrderInfo.idSalesOrders !== undefined) {
			getSalesOrderRows(salesOrderInfo.idSalesOrders);
		}

	}, [salesOrderInfo, id]);

	const getSalesOrderRows = (idSalesOrders: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'sales-order-rows/' + idSalesOrders,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				const orderRows = (resp.data || []).map((item: any) => ({
					...item,
					return_quantity: '',
					receive_loose_units: false,
					loose_unit_quantity: '',
					id_loose_unit_products: item.unit_product?.idProducts ?? null,
					is_multi_pack: !!item.is_multi_pack,
					pack_count: item.pack_count ?? 0,
					max_loose_units: item.max_loose_units ?? 0,
					unit_product: item.unit_product ?? null,
					already_returned_loose: item.already_returned_loose ?? 0,
				}))
				setOrderRows(orderRows);
				setOrderData({ ...resp.salesorder, idWarehouses: '' });
				getWarehousesByProject(resp.salesorder.idProjects);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	};

	const getWarehousesByProject = (idProjects: number) => {
		if (!idProjects) {
			setWarehouses([]);
			setWarehouse({ label: 'Select Warehouse', value: '' });
			return;
		}
		fetch(
			process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp.success && Array.isArray(resp.data)) {
					const whOptions = resp.data.map((item: any) => ({
						label: item.name,
						value: item.id_warehouses
					}));
					setWarehouses(whOptions);
				} else {
					setWarehouses([]);
				}
				setWarehouse({ label: 'Select Warehouse', value: '' });
			})
			.catch(() => {
				setWarehouses([]);
				setWarehouse({ label: 'Select Warehouse', value: '' });
			});
	};

	const handleWarehouseChange = (selected: any) => {
		setWarehouse(selected);
		setOrderData({ ...orderData, idWarehouses: selected ? selected.value : '' });
	};

	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setOrderData({ ...orderData, [e.target.name]: e.target.value });
	};

	const maxPackReturn = (row: OrderRows) =>
		parseQty(row.already_delivered) - parseQty(row.already_returned);

	const showQtyExceeded = () => {
		Swal.fire({
			icon: 'error',
			title: 'Warning',
			text: 'Quantity exceeds',
		});
	};

	const handleOrderDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedOrderRows = [...orderRows];
		const row = { ...updatedOrderRows[index] };
		const { name, value, checked } = e.target;

		if (name === 'receive_loose_units') {
			row.receive_loose_units = checked;
			if (!checked) {
				row.loose_unit_quantity = '';
			}
			updatedOrderRows[index] = row;
			setOrderRows(updatedOrderRows);
			return;
		}

		if (name === 'return_quantity') {
			const maxReturnQuantity = maxPackReturn(row);
			if (parseQty(value) > maxReturnQuantity) {
				showQtyExceeded();
				row.return_quantity = '';
				updatedOrderRows[index] = row;
				setOrderRows(updatedOrderRows);
				return;
			}
			row.return_quantity = value;
		}

		if (name === 'loose_unit_quantity') {
			const maxLoose = parseQty(row.max_loose_units);
			if (parseQty(value) > maxLoose) {
				showQtyExceeded();
				row.loose_unit_quantity = '';
				updatedOrderRows[index] = row;
				setOrderRows(updatedOrderRows);
				return;
			}
			row.loose_unit_quantity = value;
		}

		updatedOrderRows[index] = row;
		setOrderRows(updatedOrderRows);
	}

	const returnSave = async (event: any) => {
		event.preventDefault()
		if (!orderData.idWarehouses) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Please select a warehouse.',
			})
			return
		}

		const hasReturnLine = orderRows.some((row) => {
			const packQty = parseQty(row.return_quantity);
			const looseQty = row.receive_loose_units ? parseQty(row.loose_unit_quantity) : 0;
			return packQty > 0 || looseQty > 0;
		});

		if (!hasReturnLine) {
			Swal.fire({
				icon: 'warning',
				title: 'Validation',
				text: 'Enter at least one pack or loose return quantity.',
			});
			return;
		}

		for (const row of orderRows) {
			if (row.receive_loose_units && parseQty(row.loose_unit_quantity) > 0 && !row.unit_product) {
				Swal.fire({
					icon: 'warning',
					title: 'Validation',
					text: `Unit product (1×${row.unit_liters}) not found for ${row.product_name}.`,
				});
				return;
			}
		}

		setLoading(true);
		setSubmitDisable(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Return it!',
		})
		if (!confirm.value) {
			setSubmitDisable(false);
			setLoading(false);
			return
		}

		const postData = {
			return: orderData,
			returnRows: orderRows.map((row) => ({
				...row,
				return_quantity: parseQty(row.return_quantity),
				loose_unit_quantity: row.receive_loose_units ? parseQty(row.loose_unit_quantity) : 0,
				receive_loose_units: !!row.receive_loose_units,
				id_loose_unit_products: row.receive_loose_units ? row.unit_product?.idProducts ?? null : null,
			})),
		}
		const requestOptions = postRequestOptions(postData)
		try {
			let response = await fetch(
				`${process.env.REACT_APP_API_URL}sales-order-return`,
				requestOptions
			)
			let respData = await response.json()
			if (respData.success === true) {
				const successMsg = respData.successMessage
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: successMsg,
				})
				handleClose(respData.success)
			} else {
				const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
				Swal.fire({
					icon: 'error',
					title: 'Error',
					html: errorsMessage,
				})
			}
			setSubmitDisable(false);
			setLoading(false);


		} catch (error) {
			setLoading(false);
			console.log(error, 'catch the hoop')
			setSubmitDisable(false);
		}
	}

	const canReturnPacks = (row: OrderRows) =>
		parseQty(row.already_delivered) > parseQty(row.already_returned);

	const showLooseOption = (row: OrderRows) =>
		!!row.is_multi_pack && !!row.unit_product && (row.max_loose_units ?? 0) > 0;

	return (
		<Modal show={show} onHide={() => handleClose(false)} size="xl">
			<form onSubmit={returnSave}>
				<Modal.Header closeButton>
					{orderData.idSalesOrders !== 0 &&
						<Modal.Title>Product Return (Order No # {orderData.idSalesOrders})</Modal.Title>
					}
					{orderData.idSalesOrders === 0 &&
						<Modal.Title>Create New Shipment</Modal.Title>
					}
				</Modal.Header>
				<Modal.Body>
					{orderData.idProjects !== null &&
						<div className="form-group row">
							<label htmlFor="companyName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project <span className="required text-danger"></span></label>
							<div className="col-lg-5">
								{salesOrderInfo !== null &&
									<div>{orderData.projectName}</div>
								}
							</div>
						</div>
					}
					<div className="form-group row">
						<label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Warehouse <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<Select
								value={warehouse}
								onChange={handleWarehouseChange}
								options={warehouses}
								menuPosition="fixed"
								styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								isDisabled={warehouses.length === 0}
							/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="idCompanyProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Sales Order <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							{salesOrderInfo !== null &&
								<div>Order # {orderData.idSalesOrders}</div>
							}
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="returnDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Return Date <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="date" name="returnDate" id="returnDate" value={orderData.returnDate} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>

					<div className="form-group row">
						<label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<textarea name="remarks" id="remarks" rows={5} value={orderData.remarks} onChange={handleChange} className="form-control form-control-sm"></textarea>
						</div>
					</div>

					<br></br>
					<Table size='sm' bordered hover>
						<thead>
							<tr>
								<th style={{ width: '4%' }} className='text-center'>SL</th>
								<th style={{ width: '20%' }}>Product Name</th>
								<th style={{ width: '8%' }}>Packing</th>
								<th style={{ width: '8%' }}>Rate</th>
								<th style={{ width: '10%' }}>Order Qty</th>
								<th style={{ width: '10%' }}>Delivered</th>
								<th style={{ width: '8%' }}>Returned (pack)</th>
								<th style={{ width: '10%' }}>Return Qty (pack)</th>
								<th style={{ width: '22%' }}>Loose units</th>
							</tr>
						</thead>


						<tbody>

							{orderRows.map((row, index) => (
								<Fragment key={'return-row-' + index}>
									<tr>
										<td className='text-center'>{index + 1}</td>
										<td>{row.product_name}</td>
										<td>{row.packing}</td>
										<td>{row.unit_rate}</td>
										<td>{row.quantity}</td>
										<td>{row.already_delivered}</td>
										<td>{row.already_returned}</td>
										<td>
											<input
												disabled={!canReturnPacks(row)}
												type="number"
												min={0}
												name="return_quantity"
												value={row.return_quantity ?? ''}
												onChange={(event) => handleOrderDataChange(event, index)}
												className="form-control form-control-sm"
											/>
										</td>
										<td>
											{showLooseOption(row) ? (
												<div className="form-check mb-1">
													<input
														className="form-check-input"
														type="checkbox"
														id={`receive_loose_${index}`}
														name="receive_loose_units"
														checked={!!row.receive_loose_units}
														onChange={(event) => handleOrderDataChange(event, index)}
													/>
													<label className="form-check-label small" htmlFor={`receive_loose_${index}`}>
														Receive as loose units
													</label>
												</div>
											) : (
												row.is_multi_pack && !row.unit_product ? (
													<span className="text-muted small">Unit SKU 1×{row.unit_liters} not found</span>
												) : null
											)}
										</td>
									</tr>
									{showLooseOption(row) && row.receive_loose_units && (
										<tr className="bg-light">
											<td></td>
											<td colSpan={2}>
												<small className="text-muted">Loose:</small>{' '}
												{row.unit_product?.productName} ({row.unit_product?.packing})
											</td>
											<td colSpan={4}>
												<small className="text-muted">Max loose: {row.max_loose_units}</small>
											</td>
											<td colSpan={2}>
												<input
													type="number"
													min={0}
													step="any"
													name="loose_unit_quantity"
													placeholder="Loose qty"
													value={row.loose_unit_quantity ?? ''}
													onChange={(event) => handleOrderDataChange(event, index)}
													className="form-control form-control-sm"
												/>
											</td>
										</tr>
									)}
								</Fragment>
							))}



						</tbody>



					</Table>
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ProductReturn
